export enum ProductionJobStatus {
    Unknown = -1,
    Open = 0,
    Printed = 1,
    Complete = 2,
}
